import {
    POST_CURBSIDE_CHECKIN_INFO,
    POST_CURBSIDE_CHECKIN_INFO_ERROR,
    POST_CURBSIDE_CHECKIN_INFO_SUCCESS,
    GET_CURBSIDE_CHECKIN_INFO_ERROR,
    GET_CURBSIDE_CHECKIN_INFO_SUCCESS,
    PATCH_CANCEL_CURBSIDE,
    PATCH_CANCEL_CURBSIDE_SUCCESS,
    PATCH_CANCEL_CURBSIDE_ERROR,
    GET_CURBSIDE_PICKUP_ORDER_INFO,
    GET_CURBSIDE_PICKUP_ORDER_INFO_SUCCESS,
    GET_CURBSIDE_PICKUP_ORDER_INFO_ERROR,
    GET_CURBSIDE_PICKUP_STORE_INFO,
    GET_CURBSIDE_PICKUP_STORE_INFO_SUCCESS,
    GET_CURBSIDE_PICKUP_STORE_INFO_ERROR,
    GET_CURBSIDE_CHECKIN_INFO_SERVICE_DOWN,
    GET_CURBSIDE_CHECKIN_INFO_SERVICE_UP,
    RESET_CURBSIDE_CHECKIN_INFO,
    GET_INSIDE_STORE,
} from '../actionTypes/CurbsideActionTypes';

function CurbsideReducer(state = {}, action = {}) {
    switch (action.type) {
        /* Reset should be called only when moving from status or landing page
        should not combine with stopPolling as data(image, phonenumber, data for cancelcurbside)
         may be needed even after polling is stopped.
        */
        case RESET_CURBSIDE_CHECKIN_INFO:
            return {
                ...state,
                curbsideCancelDetails: { data: {} },
                postCheckInInfoDetails: { data: {} },
                getCheckInInfoDetails: { data: {} },
                getPickupOrderInfo: { data: {} },
                getPickupStoreInfo: { data: {} },
            };
        case POST_CURBSIDE_CHECKIN_INFO:
            return { ...state, postCheckInInfoDetails: { error: {}, data: {}, isLoading: true } };
        case POST_CURBSIDE_CHECKIN_INFO_ERROR:
            return {
                ...state,
                postCheckInInfoDetails: { error: action.error, data: {}, isLoading: false },
            };
        case POST_CURBSIDE_CHECKIN_INFO_SUCCESS:
            return {
                ...state,
                postCheckInInfoDetails: { data: action.response, error: {}, isLoading: false },
            };
        case GET_CURBSIDE_CHECKIN_INFO_SUCCESS:
            return {
                ...state,
                getCheckInInfoDetails: { data: action.response, error: {}, isLoading: false },
            };
        case GET_CURBSIDE_CHECKIN_INFO_ERROR:
            return {
                ...state,
                getCheckInInfoDetails: { data: {}, error: action.response, isLoading: false },
            };
        case GET_CURBSIDE_PICKUP_ORDER_INFO:
            return { ...state, getPickupOrderInfo: { isLoading: true } };
        case GET_CURBSIDE_PICKUP_ORDER_INFO_SUCCESS:
            return {
                ...state,
                getPickupOrderInfo: { data: action.response, error: {}, isLoading: false },
            };
        case GET_CURBSIDE_PICKUP_ORDER_INFO_ERROR:
            return {
                ...state,
                getPickupOrderInfo: { data: {}, error: action.error, isLoading: false },
            };
        case GET_CURBSIDE_PICKUP_STORE_INFO:
            return { ...state, getPickupStoreInfo: { isLoading: true } };
        case GET_CURBSIDE_PICKUP_STORE_INFO_SUCCESS:
            return {
                ...state,
                getPickupStoreInfo: { data: action.response, error: {}, isLoading: false },
            };
        case GET_CURBSIDE_PICKUP_STORE_INFO_ERROR:
            return {
                ...state,
                getPickupStoreInfo: { data: {}, error: action.error, isLoading: false },
            };
        case GET_CURBSIDE_CHECKIN_INFO_SERVICE_DOWN:
            return { ...state, curbsideServiceDown: { error: true } };
        case GET_CURBSIDE_CHECKIN_INFO_SERVICE_UP:
            return { ...state, curbsideServiceDown: { error: false } };
        case GET_INSIDE_STORE:
            return { ...state, getInsideStore: { error: true } };
        case PATCH_CANCEL_CURBSIDE:
            return {
                ...state,
                curbsideCancelDetails: {
                    data: {},
                    error: {},
                    statusValues: {},
                    isLoading: true,
                },
            };
        case PATCH_CANCEL_CURBSIDE_SUCCESS:
            return {
                ...state,
                curbsideCancelDetails: {
                    data: action.canceledResponse,
                    error: {},
                    statusValues: action.statusValues,
                    isLoading: false,
                },
            };
        case PATCH_CANCEL_CURBSIDE_ERROR:
            return {
                ...state,
                curbsideCancelDetails: {
                    data: {},
                    error: action.canceledError,
                    statusValues: action.statusValues,
                    isLoading: false,
                },
            };
        default:
            return state;
    }
}

CurbsideReducer.reducerName = 'curbsideDetails';
export default CurbsideReducer;
